export default "__VITE_ASSET__289e2fe6__"